import React from 'react';

function GhostText({ allQuestions }) {
  const strs = [];
  allQuestions.forEach((data, index) => {
    data.questions.forEach((item, i) => {
      strs.push(
        <span key={index + '-' + i}>
          {
            item.initial + item.title + item.hint + item.answer + item.choices[0] + item.choices[1] + item.choices[2] + item.choices[3]
            //
          }
        </span>
      );
    });
  });
  return (
    <div className="ghostContent">
      {strs}
      <span>
        {
          '0' + '1' + '2' + '3' + '4' + '5' + '6' + '7' + '8' + '9' + 'キミのおかげで未来のみどりが守られたぞありがとう!おしまい次のレベルに挑戦してみるのじゃ!おめでとう！キミも立派な植物博士じゃ！残念じゃが不正解じゃ!もう一度ヒントを参考にして考えてみるのじゃ!おっと、残り時間が減ってしまったぞ!間違わないように注意するのじゃ!ざんねん!時間切れじゃ!またチャレンジするのじゃ。ありがとう。きみのおかげでカプセルを見つけることができた。これで未来にまた緑を取り戻すことができる。緑のない未来にしないために最後の謎ときがあるようじゃ。といてみてくれ。'
          //
        }
      </span>
    </div>
  );
}

export default GhostText;
